export default __webpack_public_path__ + "static/media/07AW1JUL66.cb5993c9.jpg";